import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import type { PersonalSupportMessage } from '@module/types/centrifuge/personalMessageTypes';
import ChatGradePrefixImage from '../../../_components/ChatGradePrefixImage';
interface Props {
  item: PersonalSupportMessage;
}
export default function PersonalSupportChat(props) {
  const $ = _c(13);
  const {
    item
  } = props;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("relative flex h-[22.5px] flex-row items-center justify-start pr-[10px] text-baseFg [&>*]:inline");
    t1 = <span className="mr-1 text-cht_al_2">귓속말</span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== item.data.message.name) {
    t2 = <ChatGradePrefixImage type={item.data.message.name} className="mr-1 h-[15px] w-[15px]" />;
    $[2] = item.data.message.name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className={cn("text-nowrap text-[#6072D9]")}>서포터</span>;
    t4 = <span className={cn("ml-1 text-[#6072D9] text-[13px]")}>:</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2) {
    t5 = <div className="flex text-cht_baseFg"><div className={t0}>{t1}{t2}{t3}{t4}</div></div>;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== item.data.message.message) {
    t6 = <p className="w-full overflow-x-hidden text-left text-cht_baseFg">{item.data.message.message}</p>;
    $[8] = item.data.message.message;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="relative mb-1.5 flex flex-col whitespace-pre-wrap break-all">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}